<template>
  <div class="animated fadeIn" style="height:100%; width:auto;">
    <b-card>
      <div slot="header">
        {{this.$route.meta.title}}
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{$t('close')}}
          </button>
        </div>
      </div>
      <b-row>
        <b-col lg="10">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Agreement No.</label>
                </b-input-group-prepend>
                <b-form-input
                  readonly
                  v-model="model.no_agreement"
                  @keyup.13.native="lkuPinjamanShow=true"
                  :state="!$v.model.pinjamankey.$error"
                ></b-form-input>
                <b-input-group-append v-if="!isdetail">
                  <b-btn text="Button" @click="lkuPinjamanShow=true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width:100px">No. Kontrak</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.no_kontrak" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Debitur Name</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.CustName" disabled></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
               <b-input-group>
                <b-input-group-prepend>
                  <label>Debitur No. (CIF)</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.CustCode" disabled></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
           <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Tenor</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.tenor" readonly class="text-right"></b-form-input>
                <b-input-group-prepend><span class="input-group-text" style="width:70px;">Bulan</span></b-input-group-prepend>
              </b-input-group>
            </b-col>
            <b-col lg="6">
               <b-input-group>
                <b-input-group-prepend>
                  <label>Go Live - Maturity Date</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.startdate_frmt" readonly></b-form-input>
                <b-input-group-prepend><span class="input-group-text">-</span></b-input-group-prepend>
                    <b-form-input v-model="model.duedate_frmt" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
           <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Effective Rate (%)</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.bunga_tarifthn" readonly class="text-right"></b-form-input>
                <b-input-group-prepend><span class="input-group-text" style="width:70px;">%</span></b-input-group-prepend>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Virtual Account No</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.vanumber" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Penggunaan</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.prodname" disabled></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Cessie Group</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.pjxname" readonly></b-form-input>
                <b-input-group-prepend><span class="input-group-text">Cessie Date</span></b-input-group-prepend>
                <b-form-input v-bind:value="model.cessie_date | moment('DD MMM YYYY')" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Branch</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.branch" disabled></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>LDSK</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.LDSK" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Contract Status</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.contract_status" disabled></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>RRD Date</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.rrd_dt" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>CASSIE CURRENCY</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.cessie_ccy" readonly :class="user.matauang!=model.cessie_ccy?'bg-warning':''"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Expired Date</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.expired_date" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col lg="10">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>CONTRACT PREPAID</label>
                </b-input-group-prepend>
                 <my-number
                  class="form-control text-right"
                  v-model="model.pbb_os"
                  :precision="2"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>DOD</label>
                </b-input-group-prepend>
                 <my-number
                  class="form-control text-right"
                  v-model="model.days_over_due"
                  :precision="0"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
            <b-col lg="6">
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>OS LC Installament</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.latecharge_outstand"
                  :precision="2"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>OS Other Charge</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.os_other_charge"
                  :precision="2"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>OS Principal</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.principal_outstand"
                  :precision="2"
                  disabled
                ></my-number>
              </b-input-group>
              <b-input-group v-if="model.model_pinjaman!='PAB'">
                <b-input-group-prepend>
                  <label>OS Interest</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.interest_outstand"
                  :precision="2"
                  disabled
                ></my-number>
              </b-input-group>
              <!-- <b-input-group v-if="model.model_pinjaman!='PAB'">
                <b-input-group-prepend>
                  <label>OS Interest OD</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.interest_outstand"
                  :precision="2"
                  disabled
                ></my-number>
              </b-input-group> -->
            </b-col>
            <b-col lg="6" v-if="model.model_pinjaman=='PAB'">
              <b-input-group>
                <b-input-group-prepend>
                  <label>OS Interest</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.interest_outstand"
                  :precision="2"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>
           <b-row v-if="model.model_pinjaman=='PAB'">
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>OS Principal Undue</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.principal_outstand_undue"
                  :precision="2"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>OS Interest Undue</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.interest_outstand_undue"
                  :precision="2"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row v-if="model.model_pinjaman=='PAB'">
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Next Installment	</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.next_installment_no"
                  :precision="0"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Next Installment Date	</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.next_installment_date" disabled></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row v-if="model.model_pinjaman=='PAB'">
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Next Installment Due No	</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.next_installment_due_no"
                  :precision="0"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Next Due Date	</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.next_installment_due_date" disabled></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr />
      <b-tabs content-class justified v-model="tabIndex">
        <b-tab title="Installment Schedule" active>
          <b-row class="mb-2">
                <b-col lg="12">
                  <div class="text-right">
                    <button class="btn btn-primary mr-2" @click="printAllAngsuranpdf()" :disabled="!this.model.pinjamankey">
                      <i class="fa fa-print"></i> Seluruh Angsuran
                    </button>
                    <button class="btn btn-warning mr-2" @click="printOSAngsuranpdf()" :disabled="!this.model.pinjamankey">
                      <i class="fa fa-print"></i> Sisa Angsuran
                    </button>
                    <button class="btn btn-info text-black" @click="exportJdwlAngsuran" :disabled="!this.model.pinjamankey">
                      <i class="fa fa-file-excel-o"></i> Export Excell
                    </button>
                    <b-button variant="success" @click="getData()" class="ml-3" :disabled="!this.model.pinjamankey"><i class="fa fa-refresh"></i> Reload</b-button>
                  </div>
                  </b-col>
              </b-row>  
          <b-card align="center" no-body>
            <b-table
              sticky-header 
              class="mb-0"
              ref="table"
              outlined
              responsive
              striped
              hover
              small
              style="font-size:smaller;max-height:500px !important;"
              :items="tblData.items"
              :fields="tblFields"
              :current-page="tblData.page"
              :per-page="tblData.limit"
              :sort-by.sync="tblData.sortBy"
              :sort-desc.sync="tblData.sortDesc"
              :key="tblData.limit"
              :busy="isBusyTblAngsuran"
              :filter="filter"
              :filterIncludedFields="filterOn"
              @filtered="onFiltered"
              :tbody-tr-class="rowClass"
              show-empty
            >
              <template v-slot:cell(angsuran_ke)="data">
                <div style="width:100%;height:100%">{{ data.item.angsuran_ke }}</div>
              </template>
              <template
                v-slot:cell(tgl_jttempo)="data"
              >{{ data.item.tgl_jttempo | moment("DD/MM/YYYY") }}</template>
              <template
                v-slot:cell(inst_paid_date)="data"
              >{{ data.item.inst_paid_date | moment("DD/MM/YYYY") }}</template>
              <template
                v-slot:cell(end_of_date)="data"
              >{{ data.item.end_of_date | moment("DD/MM/YYYY hh:mm") }}</template>
              <template v-slot:cell(inst_paid_amt)="data">{{ (data.item.settle_pokok+data.item.settle_bunga) | numFormat("0,0.00") }}</template>
              <template v-slot:cell(nilai_pokok)="data">{{ data.item.nilai_pokok | numFormat("0,0.00") }}</template>
              <template v-slot:cell(nilai_bunga)="data">{{ data.item.nilai_bunga | numFormat("0,0.00") }}</template>
              <template v-slot:cell(nilai_bunga_od)="data">{{ data.item.nilai_bunga_od | numFormat("0,0.00") }}</template>
              <template v-slot:cell(angsuran)="data">{{ data.item.angsuran | numFormat("0,0.00") }}</template>
              <template v-slot:cell(outstand_pokok)="data">{{ ((data.item.outstand_pokok ||0)>0.009 ?data.item.outstand_pokok:0 ) | numFormat("0,0.00") }}</template>
              <template v-slot:cell(outstand_bunga)="data">{{ ((data.item.outstand_bunga ||0)>0.009 ? data.item.outstand_bunga:0) | numFormat("0,0.00") }}</template>
              <template v-slot:cell(outstand_denda)="data">{{ data.item.outstand_denda | numFormat("0,0.00") }}</template>
              <template v-slot:cell(akum_denda)="data">{{ data.item.akum_denda | numFormat("0,0.00") }}</template>
              <template v-slot:cell(settle_denda)="data">{{ data.item.settle_denda | numFormat("0,0.00") }}</template>
              <template
                v-slot:cell(waktupelunasan)="data"
              >{{ data.item.waktupelunasan | moment("DD MMM YYYY") }}</template>
              <template v-slot:cell(flag)="data"></template>
              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template v-slot:cell(empty)="data">
                <h4>{{ data.emptyText }}</h4>
              </template>
              <template v-slot:cell(emptyfiltered)="data">
                <h4>{{ data.emptyFilteredText }}</h4>
              </template>
              <template v-slot:cell(action)="data">
                <div class="text-center">
                  <b-dropdown text="Action" size="sm">
                    <b-dropdown-item v-if="data.item.final==0">Revisi</b-dropdown-item>
                    <b-dropdown-item v-if="data.item.model_pinjaman=='PAB'">Jadwal Angsuran</b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item v-if="data.item.cair==1">Detail Denda/Bunga RK</b-dropdown-item>
                    <b-dropdown-item v-if="data.item.cair==1">Collection Activity</b-dropdown-item>
                    <b-dropdown-item v-if="data.item.cair==1">Permohonan Pelunasan</b-dropdown-item>
                    <b-dropdown-item v-if="data.item.cair==1">History Payment & Settlement</b-dropdown-item>
                  </b-dropdown>
                </div>
              </template>
            </b-table>
            <b-row class="mt-2">
              <b-col cols="3">
                <div align="left">
                  Showing {{(tblData.page - 1) * tblData.limit + 1}}
                  to
                  <span
                    v-if="((tblData.page * tblData.limit)>tblData.total)"
                  >{{tblData.total}}</span>
                  <span v-else>{{tblData.page * tblData.limit}}</span>
                  of {{tblData.total}} entries
                </div>
              </b-col>
              <b-col cols="3">
                <b-form-group label style="margin-top:0 !important;">
                  <b-input-group>
                    <b-input-group-prepend class="mr-2">
                      <label>Limit per page</label>
                    </b-input-group-prepend>
                    <div class="d-flex">
                      <b-form-select
                        :options="[10, 15, 20, 25,50,75,100]"
                        :plain="true"
                        v-model="tblData.limit"
                        size="sm"
                        style="width:80px"
                      />
                    </div>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-input-group>
                  <b-input-group-prepend class="mr-2">
                    <label>Yg Sdh Terbayar</label>
                  </b-input-group-prepend>
                  <b-form-checkbox
                    v-model="filter"
                    value
                    unchecked-value="unpaid"
                    switch
                    style="width:50px;    padding: 8px 0px;"
                  ></b-form-checkbox>
                </b-input-group>
              </b-col>
              <b-col cols="3">
                <b-pagination
                  align="right"
                  :total-rows="tblData.total"
                  :per-page="tblData.limit"
                  v-model="tblData.page"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-card>
        </b-tab>
        <b-tab title="Payment History"  @click="getPaymentData()" :disabled='!model.pinjamankey'>
             <b-row>
                <b-col lg="12">
                    <b-input-group >
                      <b-input-group-prepend><label>Value Date</label></b-input-group-prepend>
                      <b-form-input v-model="tblDataPayment.tgl1" type="date" ></b-form-input>
                      <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                      <b-form-input v-model="tblDataPayment.tgl2" type="date" ></b-form-input>
                      <b-input-group-append>
                          <b-button variant="success" @click="getPaymentData()" class="ml-3"> <i class="fa fa-refresh"></i> Apply Filter</b-button>                
                      </b-input-group-append>
                      <b-input-group-append>
                            <b-button variant="secondary" class="ml-2" @click="clearFilterPayment()" >Clear Filter</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-col>
              </b-row>  
           <b-card align="center" no-body>
             
            <b-table
              sticky-header 
              class="mb-0"
              ref="table"
              outlined
              responsive
              striped
              hover
              small
              style="font-size:smaller;max-height:500px !important;"
              :items="tblDataPayment.items"
              :fields="tblFieldsPayment"
              :current-page="tblDataPayment.page"
              :per-page="tblDataPayment.limit"
              :sort-by.sync="tblDataPayment.sortBy"
              :sort-desc.sync="tblDataPayment.sortDesc"
              :key="tblDataPayment.limit"
              :busy="isBusyTblAngsuran"
              :filter="filter"
              :filterIncludedFields="filterOn"
              @filtered="onFiltered"
              show-empty
            >
              <template
                v-slot:cell(tglpaym)="data"
              >{{ data.item.tglpaym | moment("DD/MM/YYYY") }}</template>
              <template
                v-slot:cell(post_date)="data"
              >{{ data.item.post_date | moment("DD/MM/YYYY") }}</template>
              <template v-slot:cell(totalbank)="data">{{ data.item.totalbank | numFormat("0,0.00") }}</template>
              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template v-slot:cell(empty)="data">
                <h4>{{ data.emptyText }}</h4>
              </template>
              <template v-slot:cell(emptyfiltered)="data">
                <h4>{{ data.emptyFilteredText }}</h4>
              </template>
              <template v-slot:cell(action)="data">
                <div class="text-center">
                  
                </div>
              </template>
            </b-table>
            <b-row class="mt-2">
              <b-col cols="4">
                <div align="left">
                  Showing {{(tblDataPayment.page - 1) * tblDataPayment.limit + 1}}
                  to
                  <span
                    v-if="((tblDataPayment.page * tblDataPayment.limit)>tblDataPayment.total)"
                  >{{tblDataPayment.total}}</span>
                  <span v-else>{{tblDataPayment.page * tblDataPayment.limit}}</span>
                  of {{tblDataPayment.total}} entries
                </div>
              </b-col>
              <b-col cols="4">
                <b-form-group label style="margin-top:0 !important;">
                  <b-input-group>
                    <b-input-group-prepend class="mr-2">
                      <label>Limit per page</label>
                    </b-input-group-prepend>
                    <div class="d-flex">
                      <b-form-select
                        :options="[10, 15, 20, 25,50,75,100]"
                        :plain="true"
                        v-model="tblDataPayment.limit"
                        size="sm"
                        style="width:80px"
                      />
                    </div>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-pagination
                  align="right"
                  :total-rows="tblDataPayment.total"
                  :per-page="tblDataPayment.limit"
                  v-model="tblDataPayment.page"
                  @click="getPaymentData()"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-card>
        </b-tab>
        <b-tab title="Prepaid History"  @click="getPrepaidHistoryData()" :disabled='!model.pinjamankey'>
             <!-- <b-row>
                <b-col lg="12">
                    <b-input-group >
                      <b-input-group-prepend><label>Post Date</label></b-input-group-prepend>
                      <b-form-input v-model="tblDataPrepaid.tgl1" type="date" ></b-form-input>
                      <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                      <b-form-input v-model="tblDataPrepaid.tgl2" type="date" ></b-form-input>
                      <b-input-group-append>
                          <b-button variant="success" @click="getPrepaidHistoryData()" class="ml-3"> <i class="fa fa-refresh"></i> Apply Filter</b-button>                
                      </b-input-group-append>
                      <b-input-group-append>
                            <b-button variant="secondary" class="ml-2" @click="clearFilterPrepaid()" >Clear Filter</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-col>
              </b-row>   -->
           <b-card align="center" no-body>
             
            <b-table
              sticky-header 
              class="mb-0"
              ref="table"
              outlined
              responsive
              striped
              hover
              small
              style="font-size:smaller;max-height:500px !important;"
              :items="tblDataPrepaid.items"
              :fields="tblFieldsPrepaid"
              :current-page="tblDataPrepaid.page"
              :per-page="tblDataPrepaid.limit"
              :sort-by.sync="tblDataPrepaid.sortBy"
              :sort-desc.sync="tblDataPrepaid.sortDesc"
              :key="tblDataPrepaid.limit"
              :busy="isBusyTblAngsuran"
              :filter="filter"
              :filterIncludedFields="filterOn"
              @filtered="onFiltered"
              show-empty
            >
              <template
                v-slot:cell(tglpaym)="data"
              >{{ data.item.tglpaym | moment("DD/MM/YYYY") }}</template>
              <template
                v-slot:cell(post_date)="data"
              >{{ data.item.post_date | moment("DD/MM/YYYY") }}</template>
              <template v-slot:cell(pbb_amt)="data">{{ data.item.pbb_amt | numFormat("0,0.00") }}</template>
              <template v-slot:cell(pbb_settl)="data">{{ data.item.pbb_settl | numFormat("0,0.00") }}</template>
              <template v-slot:cell(saldo)="data">{{ data.item.saldo | numFormat("0,0.00") }}</template>
              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template v-slot:cell(empty)="data">
                <h4>{{ data.emptyText }}</h4>
              </template>
              <template v-slot:cell(emptyfiltered)="data">
                <h4>{{ data.emptyFilteredText }}</h4>
              </template>
              <template v-slot:cell(action)="data">
                <div class="text-center">
                  
                </div>
              </template>
            </b-table>
            <b-row class="mt-2">
              <b-col cols="4">
                <div align="left">
                  Showing {{(tblDataPrepaid.page - 1) * tblDataPrepaid.limit + 1}}
                  to
                  <span
                    v-if="((tblDataPrepaid.page * tblDataPrepaid.limit)>tblDataPrepaid.total)"
                  >{{tblDataPrepaid.total}}</span>
                  <span v-else>{{tblDataPrepaid.page * tblDataPrepaid.limit}}</span>
                  of {{tblDataPrepaid.total}} entries
                </div>
              </b-col>
              <b-col cols="4">
                <b-form-group label style="margin-top:0 !important;">
                  <b-input-group>
                    <b-input-group-prepend class="mr-2">
                      <label>Limit per page</label>
                    </b-input-group-prepend>
                    <div class="d-flex">
                      <b-form-select
                        :options="[10, 15, 20, 25,50,75,100]"
                        :plain="true"
                        v-model="tblDataPrepaid.limit"
                        size="sm"
                        style="width:80px"
                      />
                    </div>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-pagination
                  align="right"
                  :total-rows="tblDataPrepaid.total"
                  :per-page="tblDataPrepaid.limit"
                  v-model="tblDataPrepaid.page"
                  @click="getPrepaidHistoryData()"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-card>
        </b-tab>
        <!-- ======================================================= -->
        <b-tab title="Asset Data"  @click="getAssetData()" :disabled='!model.pinjamankey'>
           <b-card align="center" no-body>   
            <b-table
              sticky-header 
              class="mb-0"
              ref="table"
              outlined
              responsive
              striped
              hover
              small
              style="font-size:smaller;max-height:500px !important;"
              :items="tblDataAsset.items"
              :fields="tblFieldsAsset"
              :current-page="tblDataAsset.page"
              :per-page="tblDataAsset.limit"
              :sort-by.sync="tblDataAsset.sortBy"
              :sort-desc.sync="tblDataAsset.sortDesc"
              :key="tblDataAsset.limit"
              :busy="isBusyTblAngsuran"
              :filter="filter"
              :filterIncludedFields="filterOn"
              @filtered="onFiltered"
              show-empty
            >
            <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
              <template v-slot:cell(nilaijaminan)="data">{{
                data.item.nilaijaminan | numFormat('0,0.00')
              }}</template>
              <template v-slot:cell(alamat)="data">
                <div class="text-left">
                  {{ data.item.alamat || "-" }}
                <br />
                Kelurahan : {{ data.item.kelurahan }}<br />
                 Kecamatan :{{
                  data.item.kecamatan
                }}
                <br />
                Kota : {{ data.item.kota }}<br />
                Provinsi :{{ data.item.provinsi }}
                <br />
                Kode Pos : {{ data.item.kodepos }}
                </div>
               
              </template>
              <template v-slot:cell(detail)="data">
                <span v-if="data.item.tipejaminan == 'Kendaraan'">
                  <b-row>
                    <b-col md="6">- No. BPKB : {{ data.item.bpkb }}</b-col>
                    <b-col md="6">- No. STNK : {{ data.item.stnk }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col md="6">- Status STNK : {{ data.item.statusstnk }}</b-col>
                    <b-col md="6"
                      >- Tanggal STNK :
                      {{ data.item.tanggalstnk | moment("DD/MM/YY") }}</b-col
                    >
                  </b-row>
                </span>
                <span v-else>
                  <b-row>
                    <b-col md="6" v-if="(data.item.luastanah||'')!==''">
                      - Luas Tanah : {{ data.item.luastanah }} m
                      <sup>2</sup>
                    </b-col>
                    <b-col md="6"  v-if="(data.item.luasbangunan||'')!==''">
                      - Luas Bangunan : {{ data.item.luasbangunan }} m
                      <sup>2</sup>
                    </b-col>
                  </b-row>
                  - Status Sertifikat : {{ data.item.sertifikatstatus }}
                  <span v-if="data.item.sertifikatstatus === 'lainnya'"
                    >- {{ data.item.otherstatussertifikat }}</span
                  >
                  <b-row>
                    <b-col md="12" v-if="(data.item.sertifikatno||'')!==''"
                      >- No Sertifikat : {{ data.item.sertifikatno }}</b-col
                    >
                    <b-col md="12" v-if="(data.item.pemilikjaminan||'')!==''"
                      >- Sertifikat Atas Nama : {{ data.item.pemilikjaminan }}</b-col
                    >
                  </b-row>
                  <b-row>
                    <b-col md="6" v-if="(data.item.statuspbb||'')!==''">- Status PBB : {{ data.item.statuspbb }}</b-col>
                    <b-col md="6" v-if="(data.item.tanggalpbb||'')!==''">- Tanggal PBB: {{ data.item.tanggalpbb }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col md="6" v-if="(data.item.statusasuransi||'')!==''"
                      >- Status Asuransi : {{ data.item.statusasuransi }}</b-col
                    >
                    <b-col md="6"  v-if="(data.item.noimb||'')!==''">- No. IMB : {{ data.item.noimb }}</b-col>
                  </b-row>
                </span>
              </template>
              <template v-slot:cell(tgl_kontrak)="data">{{
                data.item.tgl_kontrak | moment("DD/MM/YY")
              }}</template>

              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template v-slot:cell(empty)="data">
                <h4>{{ data.emptyText }}</h4>
              </template>
              <template v-slot:cell(emptyfiltered)="data">
                <h4>{{ data.emptyFilteredText }}</h4>
              </template>
              <template v-slot:cell(emptyfiltered)="data">
                <h4>{{ data.emptyFilteredText }}</h4>
              </template>
            </b-table>
            <b-row class="mt-2">
              <b-col cols="4">
                <div align="left">
                  Showing {{(tblDataAsset.page - 1) * tblDataAsset.limit + 1}}
                  to
                  <span
                    v-if="((tblDataAsset.page * tblDataAsset.limit)>tblDataAsset.total)"
                  >{{tblDataAsset.total}}</span>
                  <span v-else>{{tblDataAsset.page * tblDataAsset.limit}}</span>
                  of {{tblDataAsset.total}} entries
                </div>
              </b-col>
              <b-col cols="4">
                <b-form-group label style="margin-top:0 !important;">
                  <b-input-group>
                    <b-input-group-prepend class="mr-2">
                      <label>Limit per page</label>
                    </b-input-group-prepend>
                    <div class="d-flex">
                      <b-form-select
                        :options="[10, 15, 20, 25,50,75,100]"
                        :plain="true"
                        v-model="tblDataAsset.limit"
                        size="sm"
                        style="width:80px"
                      />
                    </div>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-pagination
                  align="right"
                  :total-rows="tblDataAsset.total"
                  :per-page="tblDataAsset.limit"
                  v-model="tblDataAsset.page"
                  @click="getAssetData()"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-card>
        </b-tab>
        <b-tab title="Memo Pelunasan"  @click="getMemo()" :disabled='!model.pinjamankey'>
          <b-card align="center" no-body>
            <b-table
              class="mb-0"
              ref="table"
              outlined
              responsive
              striped
              hover
              small
              style="font-size:smaller;"
              :items="tblDataMemo.items"
              :fields="tblFieldsMemo"
              :current-page="tblDataMemo.page"
              :per-page="tblDataMemo.limit"
              :sort-by.sync="tblDataMemo.sortBy"
              :sort-desc.sync="tblDataMemo.sortDesc"
              :key="tblDataMemo.limit"
              :busy="isBusyTblAngsuran"
              show-empty
            >
              <!-- @row-clicked="rowClicked" -->
              <template v-slot:cell(index)="data">{{ data.index+1 }}</template>
              <template v-slot:cell(CustCode)="data">{{ data.item.CustCode}} | {{data.item.CustName}}</template>
              <template
                v-slot:cell(tglsurat)="data"
              >{{ data.item.tglsurat | moment("DD MMM YYYY") }}</template>
              <template
                v-slot:cell(tgl_kontrak)="data"
              >{{ data.item.tgl_kontrak | moment("DD MMM YYYY") }}</template>
              <template
                v-slot:cell(tglpelunasan)="data"
              >{{ data.item.tglmulaipelunasan | moment("DD MMM YYYY") }} - {{ data.item.tglpelunasan | moment("DD MMM YYYY") }}</template>
              <template v-slot:cell(ttlpayment_awal)="data">{{ data.item.ttlpayment_awal | numFormat('0,0.00') }}</template>
              <template v-slot:cell(ttllatecharge)="data">{{ data.item.ttllatecharge | numFormat('0,0.00') }}</template>
              <template v-slot:cell(diskon_amount)="data">{{ data.item.diskon_amount | numFormat('0,0.00') }}</template>
              <template v-slot:cell(ttlmustpay)="data">{{ data.item.ttlmustpay | numFormat('0,0.00') }}</template>
              <template v-slot:cell(ttlpayment_diskon)="data">{{ data.item.ttlpayment_diskon | numFormat('0,0.00') }}</template>
              <template v-slot:cell(CONTRACT_PREPAID_AMT)="data">{{ data.item.CONTRACT_PREPAID_AMT | numFormat('0,0.00') }}</template>
              <template v-slot:cell(wo_status)="data">{{ data.item.wo_status==1?'WO':'Normal'}}</template>

              <template
                v-slot:cell(status_memo)="data"
              >
                <span v-if="data.item.isreject==1">Rejected</span>
                <span v-else-if="data.item.issuccess==1">Approved</span>
                <span v-else-if="data.item.send2wf==1">Send Approval</span>
                <span v-else-if="data.item.isexpired==1">Expired</span>
                <span v-else-if="data.item.ispaid==1">PAID ({{data.item.paid_date | moment('DD-MM-YYYY')}})</span>
                <span v-else>-</span>
              </template>
              <template v-slot:cell(modified_by)="data">{{ data.item.modified_by ? data.item.modified_by : '-'}}</template>
              
              <template v-slot:cell(action)="data">
                <a :href="viewdetailmemo(data.item.pelunasankey)" target="_blank"><i class="fa fa-eye"></i> View Detail</a>
                <!-- <a @click="viewdetailmemo(data.item.pelunasankey)" target="_blank"><i class="fa fa-eye"></i> View Detail</a> -->
              </template>

              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template v-slot:cell(empty)="data">
                <h4>{{ data.emptyText }}</h4>
              </template>
              <template v-slot:cell(emptyfiltered)="data">
                <h4>{{ data.emptyFilteredText }}</h4>
              </template>
            </b-table>
            <b-row class="mt-2">
              <b-col cols="4">
                <div>
                  Showing {{(tblDataMemo.page - 1) * tblDataMemo.limit + 1}}
                  to
                  <span
                    v-if="((tblDataMemo.page * tblDataMemo.limit)>tblDataMemo.total)"
                  >{{tblDataMemo.total}}</span>
                  <span v-else>{{tblDataMemo.page * tblDataMemo.limit}}</span>
                  of {{tblDataMemo.total}} entries
                </div>
              </b-col>
              <b-col cols="4">
                <b-form-group label-cols="3" label style="margin-top:0 !important;">
                  <b-input-group>
                    <b-input-group-prepend class="mr-2">
                      <label>Limit per page</label>
                    </b-input-group-prepend>
                    <div class="d-flex">
                      <b-form-select
                        :options="[10, 15, 20, 25]"
                        :plain="true"
                        v-model="tblDataMemo.limit"
                        size="sm"
                        style="width:80px"
                      />
                    </div>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-pagination
                  align="right"
                  :total-rows="tblDataMemo.total"
                  :per-page="tblDataMemo.limit"
                  v-model="tblDataMemo.page"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-card>
        </b-tab>
        <b-tab title="Surat Peringatan"  @click="getSP()" :disabled='!model.pinjamankey'>
          <b-card align="center" no-body>
            <b-table
              class="mb-0"
              ref="table"
              outlined
              responsive
              striped
              hover
              small
              style="font-size:smaller;"
              :items="tblDataSP.items"
              :fields="tblFieldsSP"
              :current-page="tblDataSP.page"
              :per-page="tblDataSP.limit"
              :sort-by.sync="tblDataSP.sortBy"
              :sort-desc.sync="tblDataSP.sortDesc"
              :key="tblDataSP.limit"
              :busy="isBusyTblAngsuran"
              show-empty
            >
              <template v-slot:cell(index)="data">{{ data.index+1 }}</template>
              <template v-slot:cell(debitur_name)="data">{{ data.item.CustCode}} | {{data.item.CustName}}</template>
              <template
                v-slot:cell(tgl_kontrak)="data"
              >{{ data.item.tgl_kontrak | moment("DD MMM YYYY") }}</template>
              <template
                v-slot:cell(tglsurat)="data"
              >{{ data.item.tglsurat | moment("DD MMM YYYY") }}</template>
              <template v-slot:cell(tunggakanpokok)="data">{{ data.item.tunggakanpokok | numFormat }}</template>
              <template v-slot:cell(tunggakandenda)="data">{{ data.item.tunggakandenda | numFormat }}</template>
              <template v-slot:cell(tunggakanbunga)="data">{{ data.item.tunggakanbunga | numFormat }}</template>
              <template v-slot:cell(tunggakantotal)="data">{{ data.item.tunggakantotal | numFormat }}</template>
              <template v-slot:cell(modified_by)="data">{{ data.item.modified_by ? data.item.modified_by : '-'}}</template>
              <template v-slot:cell(action)="data">
                <a :href="viewdetailsp(data.item.suratkey)" target="_blank"><i class="fa fa-eye"></i> View Detail</a>
              </template>

              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template v-slot:cell(empty)="data">
                <h4>{{ data.emptyText }}</h4>
              </template>
              <template v-slot:cell(emptyfiltered)="data">
                <h4>{{ data.emptyFilteredText }}</h4>
              </template>
            </b-table>
            <b-row class="mt-2">
              <b-col cols="4">
                <div>
                  Showing {{(tblDataSP.page - 1) * tblDataSP.limit + 1}}
                  to
                  <span
                    v-if="((tblDataSP.page * tblDataSP.limit)>tblDataSP.total)"
                  >{{tblDataSP.total}}</span>
                  <span v-else>{{tblDataSP.page * tblDataSP.limit}}</span>
                  of {{tblDataSP.total}} entries
                </div>
              </b-col>
              <b-col cols="4">
                <b-form-group label-cols="3" label style="margin-top:0 !important;">
                  <b-input-group>
                    <b-input-group-prepend class="mr-2">
                      <label>Limit per page</label>
                    </b-input-group-prepend>
                    <div class="d-flex">
                      <b-form-select
                        :options="[10, 15, 20, 25]"
                        :plain="true"
                        v-model="tblDataSP.limit"
                        size="sm"
                        style="width:80px"
                      />
                    </div>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-pagination
                  align="right"
                  :total-rows="tblDataSP.total"
                  :per-page="tblDataSP.limit"
                  v-model="tblDataSP.page"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-card>
        </b-tab>
      </b-tabs>
      
    </b-card>
    <b-modal
      v-model="lkuPinjamanShow"
      size="lg"
      :hide-footer="true"
      title="Daftar Pinjaman"
      :centered="true"
    >
      <lku-pinjaman @click="onSelectLkuPinjaman" ></lku-pinjaman>
    </b-modal>
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>   
  </div>
</template>

<style lang="scss" scoped>
  .table-red-text{
    color:red;
  }
</style>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import Loading from 'vue-loading-overlay';

import myNumber from "../../components/my-number";
import lkuPinjaman from "./lkuPinjaman";
import pinjaman from "../../apis/pinjamankredit";
import payment from "../../apis/pinjamanpayment";
import asset from "../../apis/agunankredit";
import pelunasan from "../../apis/pelunasanpinjaman";
import suratperingatan from "../../apis/suratperingatan";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { Loading, myNumber, lkuPinjaman },
  mixins: [validationMixin],
  validations: {
    model: {
      pinjamankey: { required },
    },
  },
  data() {
    return {
      showReport:false,
      reportUrl:null,
      isLoading:false,
      tabIndex:0,
      model: { pinjamankey: "",printall:1,
      next_installment_no:0,
      next_installment_date:'',
      next_installment_due_no:0,
      next_installment_due_date:'',
      principal_outstand_undue:0,
      interest_outstand_undue:0,
      os_other_charge:0,model_pinjaman:''
      },
      lkuPinjamanShow: false,
      tblData: {
        page: 1,
        limit: 50,
        total: 0,
        tgl1: this.$store.state.user.tglaktif,
        tgl2: this.$store.state.user.akhirbln,
        sortBy: "nokontrak",
        sortDesc: false,
        items:[]
      },
      tblFields:[
        {
          key: "angsuran_ke",
          label: "Angsuran Ke-",
          thStyle: "width:40px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "tgl_jttempo",
          label: "Tgl. Jatuh Tempo",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "angsuran",
          label: "Angsuran (IDR)",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "inst_paid_amt",
          label: "Installment Paid",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "inst_paid_date",
          label: "Tgl. Bayar",
          thStyle: "width:40px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "nilai_pokok",
          label: "Pokok",
          thStyle: "width:60px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "nilai_bunga",
          label: "Bunga(IDR)",
          thStyle: "width:60px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "outstand_pokok",
          label: "Outstand Pokok",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "outstand_bunga",
          label: "Outstand Bunga",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "lc_days",
          label: "Keterlambatan\n (Hari)",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        
        {
          key: "akum_denda",
          label: "LC Amt.",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "settle_denda",
          label: "LC Amt. Paid",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        }
      ],
      tblDataPayment: {
        page: 1,
        limit: 50,
        total: 0,
        tgl1: '',
        tgl2: '',
        sortBy: "tglpaym",
        sortDesc: true,
        pinjamankey:'',
        items:[]
      },
      tblDataPrepaid: {
        page: 1,
        limit: 50,
        total: 0,
        tgl1: '',
        tgl2: '',
        sortBy: "post_date",
        sortDesc: false,
        pinjamankey:'',
        items:[]
      },
      tblDataAsset: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "jaminankey",
        sortDesc: false,
        pemilikjaminan: null,
        lokasijaminan: null,
        nilai1: 0,
        nilai2: 0,
        no_kontrak: null,
        tipejaminan: "",
        statusasuransi: "",
        jaminankeys: [],
        sourceproject: this.$store.state.user.compcode||"",
      },
      tblDataMemo: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "tglpelunasan",
        sortDesc: false,
        model_pinjaman: "",
        collector_id: "",
        collectability: "",
        status: "",nosurat:""
      },
      tblDataSP: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "tglsurat",
        sortDesc: false,
        model_pinjaman: "",
        collector_id: "",
        collectability: "",
        kolektibiltas: "",
        jenissuratkey: null,
      },
      isdetail: false,
      isBusyTblAngsuran: false,
      filter: "",
      filterOn: ["statuspay"],
    };
  },
  props: ["modelpinjaman"],
  computed: {
    tblFieldsPayment() {
      const fields = [
        {
          key: "paymno",
          label: "Payment No",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-left",
          sortable: true,
        },
        {
          key: "group_pym",
          label: "Payment Type",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-left",
          sortable: true,
        },
        {
          key: "tglpaym",
          label: "Value Date",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "post_date",
          label: "Post Date",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        
        {
          key: "createby",
          label: "Issued By",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "totalbank",
          label: "Payment",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        }
      ];
      return fields;
    },
    tblFieldsPrepaid() {
      const fields = [
        {
          key: "group_pym",
          label: "Payment Type",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-left",
        },
        {
          key: "tglpaym",
          label: "Value Date",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-right",
        },
        {
          key: "post_date",
          label: "Post Date",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
        },
        
        {
          key: "createby",
          label: "Issued By",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
        },
        {
          key: "pbb_amt",
          label: "Prepaid Payment",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
        },
        {
          key: "pbb_settl",
          label: "Prepaid Alloction",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
        },
        {
          key: "saldo",
          label: "TRANSACTION AMOUNT",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
        },
        {
          key: "action",
          label: "Action",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
        }
      ];
      return fields;
    },
    tblFieldsAsset() {
      const fields = [
        { key: "index", label: "#" },
        {
          key: "namajaminan",
          label: "Nama Jaminan",
          thClass: "text-center",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "tipejaminan",
          label: "Tipe Jaminan",
          thClass: "text-center",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "nilaijaminan",
          label: "Nilai Jaminan",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "pemilikjaminan",
          label: "Pemilik Jaminan",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "alamat",
          label: "Alamat",
          thClass: "text-center",
          thStyle: "width:1500px",
          sortable: true,
        },
        {
          key: "detail",
          label: "Detail",
          thClass: "text-center",
          thStyle: "width:2000px",
          tdClass: "text-left",
          sortable: true,
        },
        {
          key: "kronologis_note",
          label: "Note",
          thClass: "text-center",
          thStyle: "width:2000px",
          tdClass: "text-left",
          sortable: true,
        },
        // {
        //   key: "no_kontrak",
        //   label: "No Kontrak",
        //   thClass: "text-center",
        //   thStyle: "width:500px",
        //   sortable: true,
        // },
        // {
        //   key: "tgl_kontrak",
        //   label: "Tgl. Kontrak",
        //   thClass: "text-center",
        //   thStyle: "width:500px",
        //   sortable: true,
        // },
        // {
        //   key: "tenor",
        //   label: "Tenor (Bln)",
        //   thClass: "text-center",
        //   tdClass: "text-right",
        //   thStyle: "width:200px",
        //   sortable: true,
        // },
      ];
      return fields;
    },
    tblFieldsMemo() {
      const fields = [
         {
          key: "tglsurat",
          label: "Tgl. Memo",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "nosurat",
          label: "No. Memo",
          thStyle: "width:140px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "no_kontrak",
          label: "No. Kontrak",
          thStyle: "width:140px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "CustCode",
          label: "CIF | Debitur Name",
          thStyle: "width:150px",
          thClass: "text-center",
          sortable: true,
        },
         {
          key: "tipepelunasan",
          label: "Jenis Pelunasan",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "tglpelunasan",
          label: "Tgl. Pelunasan",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "ttlpayment_awal",
          label: "Sisa Pinjaman / Angsuran",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "ttlpayment_diskon",
          label: "Ttl. Diskon",
          thStyle: "width:140px",
          tdClass: "text-right",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "CONTRACT_PREPAID_AMT",
          label: "Ttl. Prepaid",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
        },
        {
          key: "ttlmustpay",
          label: "Ttl. Pelunasan",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "status_memo",
          label: "Status Memo",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "createby",
          label: "Issued By",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "modified_by",
          label: "Modified By",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        }
      ];
      return fields;
    },
    tblFieldsSP() {
      const fields = [
        {
          key: "no_kontrak",
          label: "No. Kontrak",
          thStyle: "width:140px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "debitur_name",
          label: "Debitur",
          thStyle: "width:150px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "model_pinjaman",
          label: "Model",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "nosurat",
          label: "No. SP",
          thStyle: "width:90px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "tglsurat",
          label: "Tgl. SP",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "namasurat",
          label: "Jenis SP",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "kolektibiltas",
          label: "Kolektibiltas",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "tunggakanpokok",
          label: "Tunggakan Pokok",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "tunggakandenda",
          label: "Tunggakan Denda",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "tunggakanbunga",
          label: "Tunggakan Bunga",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "tunggakantotal",
          label: "Tunggakan Total",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "createby",
          label: "DIterbitkan Oleh",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "modified_by",
          label: "Modified by",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        }
      ];
      return fields;
    },
    user(){
      return this.$store.state.user;
    }
  },
  beforeUpdate: function () {},
  created: async function () {
          console.log('this.$store.state',this.$store.state.matauang);

    if (this.$route.params.pinjamankey) {
      this.model.pinjamankey = this.$route.params.pinjamankey;
      this.isdetail = true; // flag dari action pada daftar pinjaman
      this.getData();
    } else {
      this.model.model_pinjaman = this.modelpinjaman;
    }
  },
  watch:{
    "model.model_pinjaman"(val){
      let fields = [
        {
          key: "angsuran_ke",
          label: "Angsuran Ke-",
          thStyle: "width:40px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "tgl_jttempo",
          label: "Tgl. Jatuh Tempo",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "angsuran",
          label: "Angsuran (IDR)",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "inst_paid_amt",
          label: "Installment Paid",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "inst_paid_date",
          label: "Tgl. Bayar",
          thStyle: "width:40px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "nilai_pokok",
          label: "Pokok",
          thStyle: "width:60px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "nilai_bunga",
          label: "Bunga(IDR)",
          thStyle: "width:60px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "outstand_pokok",
          label: "Outstand Pokok",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "outstand_bunga",
          label: "Outstand Bunga",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "lc_days",
          label: "Keterlambatan\n (Hari)",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        
        {
          key: "akum_denda",
          label: "LC Amt.",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "settle_denda",
          label: "LC Amt. Paid",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        }
      ];
      if(val==='PRK'){
        fields = [
          {
            key: "angsuran_ke",
            label: "Angsuran Ke-",
            thStyle: "width:40px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "tgl_jttempo",
            label: "Tgl. Jatuh Tempo",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          // {
          //   key: "angsuran",
          //   label: "Angsuran (IDR)",
          //   thStyle: "width:140px",
          //   thClass: "text-center",
          //   tdClass: "text-right",
          //   sortable: true,
          // },
          {
            key: "inst_paid_amt",
            label: "Installment Paid",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "inst_paid_date",
            label: "Tgl. Bayar",
            thStyle: "width:40px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "nilai_pokok",
            label: "Pokok",
            thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "nilai_bunga",
            label: "Bunga(IDR)",
            thStyle: "width:60px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "nilai_bunga_od",
            label: "Bunga OD(IDR)",
            thStyle: "width:70px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "outstand_pokok",
            label: "Outstand Pokok",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "outstand_bunga",
            label: "Outstand Bunga",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "lc_days",
            label: "Keterlambatan\n (Hari)",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          
          {
            key: "akum_denda",
            label: "LC Amt.",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "settle_denda",
            label: "LC Amt. Paid",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          }
        ];
      }

      this.tblFields= fields;
    },
  },
  methods: {
    rowClass(item, type) {
      const today = moment().format('YYYY-MM-DD');
        if ((item && item.outstand_bunga ||0)>0.009 || (item && item.outstand_pokok||0) > 0.009) {
          if(moment(today).diff(moment(item.tgl_jttempo),'days')>-1){
            return 'text-danger';
          }else{
            return '';
          }
            
        }else{
          return '';
        }
        
      },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },
    onSelectLkuPinjaman(_selected) {
      this.model.pinjamankey = _selected.pinjamankey;

       this.tblDataPayment= {
            page: 1,
            limit: 50,
            total: 0,
            tgl1: '',
            tgl2: '',
            sortBy: "tglpaym",
            sortDesc: true,
            pinjamankey:'',
            items:[]
          },
          this.tabIndex=0;

      this.getData();
      this.lkuPinjamanShow = false;
    },
    close() {
      router.push({ name: "loan.pinjaman" });
    },
    async getData() {
      try {
        this.isLoading = true;
        const pinjamankey = this.model.pinjamankey;
        this.isBusyTblAngsuran = true;
        const [data] = await pinjaman.detail(pinjamankey);
        const dtpinjaman = data[0][0];
        console.log('dtpinjaman',dtpinjaman);
        for (const key in dtpinjaman) {
          if (dtpinjaman.hasOwnProperty(key)) {
            this.model[key] = dtpinjaman[key];
          }
        }
        this.model.tgl_kontrak = moment(this.model.tgl_kontrak).format(
          "YYYY-MM-DD"
        );
        this.model.principal_outstand = dtpinjaman.principal_outstand -  dtpinjaman.cessie_adjusment_principle;
        this.model.interest_outstand = dtpinjaman.interest_outstand -  dtpinjaman.cessie_adjusment_interest;

        this.model.startdate_frmt = this.model.startdate ? moment(this.model.startdate).format('DD-MM-YYYY') : "";
        this.model.duedate_frmt = this.model.duedate ? moment(this.model.duedate).format('DD-MM-YYYY') : "";
        this.model.rrd_dt = this.model.rrd_dt ? moment(this.model.rrd_dt).format('DD-MM-YYYY') : "";
        this.model.expired_date = this.model.expired_date ? moment(this.model.expired_date).format('DD-MM-YYYY') : "";
        this.model.next_installment_date= this.model.next_installment_date ? moment(this.model.next_installment_date).format('DD-MM-YYYY') : this.model.next_installment_date;
        this.model.next_installment_due_date= this.model.next_installment_due_date ? moment(this.model.next_installment_due_date).format('DD-MM-YYYY') : this.model.next_installment_due_date;
        this.model.os_other_charge = (this.model.charge_rcv_amt || 0) - (this.model.charge_rcv_waived_amt || 0 + this.model.fee_charge_rcv_paid_amt || 0);
        
        this.listAgunan = data[1];
        data[2].map((item, index) => {
          if (item.outstand_bunga >0.009 || item.outstand_pokok > 0.009) {
            data[2][index].statuspay = "unpaid";
          } else {
            data[2][index]._rowVariant = "success";
            data[2][index].statuspay = "paid";
          }
        });
        console.log('data[2]',data[2]);
        this.tblData.items = data[2];
        
        this.tblData.total = data[2].length;
        this.tblData.limit = data[2].length;
       
        this.isBusyTblAngsuran = false;
        // toastr.clear;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    },
    printOSAngsuranpdf(){
      this.model.printall=0;
      this.printpdf();
    },
    printAllAngsuranpdf(){
      this.model.printall=1;
      this.printpdf();
    },
    async printpdf(){
      try {
        this.isLoading=true;
        this.reportUrl = await pinjaman.printjdwlangsuran(this.model);
        this.isLoading=false;
        this.showReport= true;
      } catch (error) {
        this.showReport= false;
        this.isLoading=false;
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    },
    async exportJdwlAngsuran(){
      try {
          this.isLoading=true;
          await pinjaman.exportJdwlAngsuran(this.model.pinjamankey);
          this.isLoading=false;
      } catch (error) {
        this.isLoading=false;
        console.log("error : ", error);
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async getAssetData(){
      try {
        this.isLoading=true;
        const list = await asset.getAsset(this.model.pinjamankey);
        this.tblDataAsset.items=list;
        this.tblDataAsset.total = list.length;
        this.isLoading=false; 
      } catch (error) {
        this.isLoading = false;
        console.log("error : ", error);
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },

    async getMemo(){
      try {
        this.isLoading=true;
        const list = await pelunasan.getMemoPinjaman(this.model.pinjamankey);
        this.tblDataMemo.items=list;
        this.tblDataMemo.total = list.length;    
        this.isLoading=false; 
        //return list;
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },

    async getSP(){
      try {
        this.isLoading=true;
        const list = await suratperingatan.getSP(this.model.pinjamankey);
        this.tblDataSP.items=list;
        this.tblDataSP.total = list.length;    
        this.isLoading=false; 
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async getPaymentData(){
      try {
        this.isLoading=true;
        this.tblDataPayment.sortDir = this.tblDataPayment.sortDesc ? "desc" : "asc";
        this.tblDataPayment.pinjamankey = this.model.pinjamankey
        const list = await payment.getpaymentandallocationprepaidhistory(this.tblDataPayment);
        this.tblDataPayment.items=list;    
        this.isLoading=false;   
      } catch (error) {
        this.isLoading=false;
        console.log("error : ", error);
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async getPrepaidHistoryData(){
      try {
        this.isLoading=true;
        this.tblDataPrepaid.sortDir = this.tblDataPrepaid.sortDesc ? "desc" : "asc";
        this.tblDataPrepaid.pinjamankey = this.model.pinjamankey
        let list = await payment.getprepaidhistory(this.tblDataPrepaid);
        for (let index = 0; index < list.length; index++) {
          const item = list[index];
           if(index==0){
            list[index].saldo = (item.pbb_amt - item.pbb_settl)
          }else{
            list[index].saldo = (item.pbb_amt - item.pbb_settl) + list[index-1].saldo
          }
          
        }
        
        let saldo = 0
        this.tblDataPrepaid.items=list.reduce((arr=[],data,index)=>{
          data.saldo = (data.pbb_amt - data.pbb_settl) + saldo;
          saldo += (data.pbb_amt - data.pbb_settl); 
          saldo = parseFloat(saldo.toFixed(2));
          arr.push(data);
          return arr;
        },[]);    
        this.isLoading=false;   
      } catch (error) {
        this.isLoading=false;
        console.log("error : ", error);
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    clearFilterPayment(){
      this.tblDataPayment.tgl1= '';
      this.tblDataPayment.tgl2= '';
    },
    clearFilterPrepaid(){
      this.tblDataPrepaid.tgl1= '';
      this.tblDataPrepaid.tgl2= '';
    },
    viewdetailmemo(pelunasankey){
      const url = router.resolve({name:'loan.pelunasanmemoview',params:{pelunasankey}}).route.path;
      return `#`+url;
    },
    viewdetailsp(suratkey){
      const url = router.resolve({name:'loan.suratperingatanview',params:{suratkey}}).route.path;
      return `#`+url;
    },
  },
};
</script>